import TableList from "@components/templates/tablelist";
import {
    HttpDdSystems,
    HttpUclocaleList,
    HttpUclocaleCodeRemove,
    HttpUclocaleRowDel,
    HttpUclocaleRowGetById,
    HttpUclocaleRowGetByCode
} from "@/service/ucadm";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true },
            sysList: []
        };
    },
    created() {
        this.getSyslist();
    },
    components: {
        compUpdate
    },
    methods: {
        ajaxRequest: HttpUclocaleList,
        async getSyslist() {
            const response = await HttpDdSystems();
            if (response) {
                this.sysList = (response.data || []).map(function (item) {
                    return {
                        value: item.id,
                        label: `${item.label}(${item.title})`
                    };
                });
            }
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        type: "add",
                        title: "添加多语言条目",
                        component: "compUpdate",
                        width: 680,
                        showFooter: false
                    };
                    break;
                case "edit":
                    this.operate = {
                        show: true,
                        params,
                        type: "edit",
                        title: "编辑多语言条目",
                        component: "compUpdate",
                        width: 680,
                        showFooter: false
                    };
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "删除多语言条目",
                        ajaxRequest: HttpUclocaleRowDel
                    };
                    break;
                case "upload":
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_UC + "/api/v1/BizLocaleMessage/batchImport",
                        name: "multipartFile",
                        component: "compUpload"
                    };
                    break;
                case "download":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_UC + "/api/v1/BizLocaleMessage/batchExport",
                        { ids: params },
                        "download"
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { langKey, id, systemId } = row;
            return [
                {
                    label: "编辑",
                    show: true,
                    params: { code: langKey, systemId },
                    operate: "edit"
                },
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: "del"
                }
            ];
        }
    },
    computed: {
        ToolsData() {
            return [
                {
                    name: "添加多语言条目",
                    operate: "add",
                    theme: "primary"
                },
                {
                    name: "导入",
                    operate: "upload",
                    theme: "info"
                },
                {
                    name: "导出",
                    operate: "download",
                    theme: "success",
                    batch: true
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: "标识",
                    tag: "vInput",
                    key: "CN_langKey",
                    show: true
                },
                {
                    label: "内容",
                    tag: "vInput",
                    key: "CN_langValue",
                    show: true
                },
                {
                    label: "语言",
                    tag: "vSelect",
                    key: "EQ_locale",
                    show: true,
                    options: [
                        {
                            label: "所有",
                            value: ""
                        },
                        {
                            label: "中文",
                            value: "zh-CN"
                        },
                        {
                            label: "English",
                            value: "en"
                        }
                    ]
                },
                {
                    label: "所属系统",
                    tag: "vSelect",
                    key: "EQ_systemId",
                    show: true,
                    options: this.sysList
                }
            ];
        },
        columns() {
            return [
                {
                    type: "selection",
                    formName: "id",
                    width: 40,
                    align: "center"
                },
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: "标识",
                    key: "langKey",
                    sortable: true
                },
                {
                    title: "内容",
                    key: "langValue"
                },
                {
                    title: "所属系统",
                    key: "langValue",
                    render: (h, { row }) => {
                        return (
                            this.sysList.find(function (item) {
                                return item.value == row.id;
                            }) || {}
                        ).label;
                    }
                },
                {
                    title: "维护时间",
                    key: "opAt"
                }
            ];
        }
    }
};
